var map = {
	"./birthday.svg": "4810",
	"./blue-palm.svg": "2c87",
	"./country.svg": "b85f",
	"./pink-mimosa.svg": "9a1f",
	"./purple-cow.svg": "9479f",
	"./rip.svg": "5326"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c37b";